<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        재직증명신청
      </v-col>
    </v-row>
    <div class="apply-list px-6 overflow-y-auto">
      <v-text-field label="신청서종류" v-model="codeNm" readonly ></v-text-field>
      <v-text-field
        label="신청서코드"
        v-model="applCd"
        readonly
        v-show="false"

      ></v-text-field>
      <v-text-field label="재직기간" v-model="period" readonly ></v-text-field>
      <v-textarea label="주소" rows="2" v-model="address" maxlenth="200" ></v-textarea>
      <v-text-field
        label="용도"
        v-model="purpose"
        @click="applLevelSheet1 = !applLevelSheet1"
        class="bottom--box"
        append-icon="mdi-chevron-right"
        readonly
      ></v-text-field>
      <v-text-field label="제출처" v-model="submitOffice"></v-text-field>
      <v-text-field label="메일주소" v-model="emailAddr" v-show="emailAddrShow"></v-text-field>
      <v-text-field label="기타" v-model="note"></v-text-field>
      <div class="borderLine-wrap"  v-show="fileShow">
        <span class="borderLine-title">첨부파일</span>
        <v-btn
          elevation="0"
          text
          fab
          width="24"
          height="24"
          class="ml-auto"
          @click="fileFlag = !fileFlag"
        >
          <v-icon size="24" color="#9ca3ab">mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
    <bgf-attach-file-add ref="bgfAttachFile" />
    <v-bottom-navigation fixed scroll-threshold="500" height="96">
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applovalPage"
          >
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
    <bgf-attach-file-bottom-select
      :flag="fileFlag"
      @selectItem="changeFile"
    ></bgf-attach-file-bottom-select>
    <bottom-select
      :flag="applLevelSheet1"
      :list="codeList1"
      :title="selecttitle1"
      @selectItem="changeApplLine1"
    ></bottom-select>
  </div>
</template>

<script>
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg/
import routerNames from '@/const/routerConstants';
import { getReCertAppList, getPurposeList , getLeaAbsAppStatusCd } from '@/api/workStatus';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import BottomSelect from '@/components/application/form/BottomSelect.vue';
import BgfAttachFileAdd from '@/components/application/form/BgfAttachFileAdd.vue';
import BgfAttachFileBottomSelect from '@/components/application/form/BgfAttachFileBottomSelect.vue';

export default {
  data: () => ({
    codeNm: '',
    applCd: '',
    address: '',
    period: '',
    applLevelSheet1: false, // 용도 화면플래그
    selecttitle1: '용도',
    codeList1: [],
    note: '',
    emailAddr: '',
    emailAddrShow: false,
    purpose: '',
    purposeCd: '',
    submitOffice: '',
    fileFlag: false,
    fileShow: true,
    statusCd: '',
  }),

  components: {
    IconApprovalDoc,
    BottomSelect,
    BgfAttachFileAdd,
    BgfAttachFileBottomSelect,
  },

  computed: {
    ...mapGetters('ELA', [
      'GET_S_YMD',
      'GET_E_YMD',
      'GET_UI_INFO',
      'GET_ELA_APPL_PARAM',
    ]),
    ...mapGetters([
      'GET_CODE',
      'GET_CODE_NM',
      'GET_USER_DATA',
      'GET_FILE_SEQ',
      'GET_PARAMS',
    ]),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_BTN
      }px;`;
    },
  },

  methods: {
    changeFile(levelObj) {
      if (levelObj === 'C') {
        this.$refs.bgfAttachFile.callCamera();
      } else if (levelObj === 'G') {
        this.$refs.bgfAttachFile.callGallery();
      }

      this.fileFlag = false;
    },
    async changeApplLine1(levelObj) {
      console.dir(levelObj);
      this.purposeCd = levelObj.code;
      this.purpose = levelObj.codeNm;
      // 대상자명선택화면닫기
      this.applLevelSheet1 = false;
    },

    async applovalPage() {

      if (this.address === null) {
        alert('주소를 입력해 주세요');
        return;
      }

      if (this.purpose.trim() === '') {
        alert('용도를 선택해 주세요');
        return;
      }

      if (this.submitOffice.trim() === '') {
        alert('제출처를 입력해 주세요');
        return;
      }

      if ( this.statusCd === 'CA' ) { //휴직자는 증명서 받을 메일주소 입력 필수체큰
        if(this.emailAddr.trim() === '')
        {
            alert('메일주소를 입력해 주세요');
            return;
        }
        else if(this.emailAddr.trim().indexOf('@') < 0)
        {
            alert('올바른 메일주소를 입력해 주세요');
            return;
        }

      }

      if(this.purpose === '기타') {
        if (this.note.trim() === '') {
          alert('기타를 입력해 주세요');
          return;
        }
      }

      if (this.GET_UI_INFO.fileEssentialYn === 'Y') {
        if(this.GET_FILE_SEQ === '') {
          alert('파일 첨부는 필수 입니다');
          return;
        }
      }

      const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: this.GET_ELA_APPL_PARAM.searchApplCd,
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
        searchApplYmd: dayjs().format('YYYYMMDD'),
        searchApplName: this.GET_USER_DATA.ssnName,
        ssnSabun: this.GET_USER_DATA.ssnSabun,
        authPg: 'A', // A신청, R결제
        pathSeq: '',
        applStatusCd: '31', //수신처리중
        fileSeq: this.GET_FILE_SEQ,
        procExecYn: this.GET_UI_INFO.procExecYn,
        etc01: this.GET_UI_INFO.etc01,
        etc02: this.GET_UI_INFO.etc02,
        etc03: this.GET_UI_INFO.etc03,
        etc04: this.GET_UI_INFO.etc04,
        etc05: this.GET_UI_INFO.etc05,
        applTypeCd: '10', //본인신청
        codeNm: this.codeNm,
        applCd: this.GET_ELA_APPL_PARAM.searchApplCd,
        address: this.address,
        period: this.period,
        note: this.note,
        emailAddr: this.emailAddr,
        purpose: this.purpose,
        purposeCd: this.purposeCd,
        submitOffice: this.submitOffice,
      };

      this.$store.commit('SET_AUTHPG', 'A');
      this.$store.commit('SET_PARAMS', params);
      this.$store.dispatch('ELA/SET_RECERT_PARAMS', params);
      this.$router.push(routerNames.ApprovalLine);
    },

    call(sdate, edate) {
      var sdd = sdate;
      var edd = edate;

      var ar1 = sdd.split('-');
      var ar2 = edd.split('-');
      var da1 = new Date(ar1[0], ar1[1], ar1[2]);
      var da2 = new Date(ar2[0], ar2[1], ar2[2]);
      var dif = da2 - da1;
      var cDay = 24 * 60 * 60 * 1000; // 시 * 분 * 초 * 밀리세컨
      var cMonth = cDay * 30; // 월 만듬
      var cYear = cMonth * 12; // 년 만듬
      var mYear = parseInt(dif / cYear) * 12;     
    
      if (sdd && edd) {
        this.period =
          sdate +
          ' ~ ' +
          edate +
          ' (' +
          parseInt(dif / cYear) +
          '년' +
          parseInt(dif / cMonth - mYear) +
          '개월)';
      }
    },
  },

  async mounted() {
    this.codeNm = this.GET_CODE_NM;
    this.applCd = this.GET_CODE;
    const params = {
      applCd: this.GET_CODE,
    };

    let response = await getReCertAppList(params);

    let statusdata = await getLeaAbsAppStatusCd(params);

    this.statusCd = statusdata.data.data.statusCd;
    
    if (response.data.data[0] !== undefined) {
      this.address = response.data.data[0].address;
      this.call(response.data.data[0].empYmd, response.data.data[0].currYmd);
    }

    params.grcodeCd = 'C80001';
    response = await getPurposeList(params);
    this.codeList1 = response.data.data;

    this.purpose =
      this.GET_PARAMS.purpose === undefined ? '' : this.GET_PARAMS.purpose;

    this.submitOffice =
      this.GET_PARAMS.submitOffice === undefined
        ? ''
        : this.GET_PARAMS.submitOffice;

    this.note = this.GET_PARAMS.note === undefined ? '' : this.GET_PARAMS.note;

    this.emailAddr = this.GET_PARAMS.emailAddr === undefined ? '' : this.GET_PARAMS.emailAddr;

    if (this.GET_UI_INFO.fileYn === 'N') {
      this.fileShow = false;
    }
    
    if (this.statusCd === 'CA') { //휴직자는 증명서 받을 메일주소 입력
      this.emailAddrShow = true;
    }
  },
};
</script>

<style>

</style>
